import { useState } from "react";
import type { TldrawCanvasPanelProps } from "./TldrawCanvasPanel";

import { TldrawCanvasPanel as CanvasPanel } from "./TldrawCanvasPanel";

export const TldrawCanvasPanel = (props: TldrawCanvasPanelProps) => {
  const [opened, setOpened] = useState(props.isOpen);
  if (props.isOpen && !opened) setOpened(true);
  if (!props.isOpen && !opened) return null;
  return <CanvasPanel {...props} />;
};
